import React from "react";
import insurancevoyage from "../assets/images/insurancevoyage.webp";

const Insurance = () => {
  return (
    <>
      <section
        className=" md:pt-12 md:pb-24 py-12 md:scroll-mt-20 md:px-0 px-4"
        id="insurance"
      >
        <div className="mx-auto flex flex-wrap max-w-7xl bg-[#0755AD] items-center justify-between md:p-16 py-12 px-6 rounded-lg">
          {/* Left Content */}
          <div className="md:w-[54%]">
            <span className=" inline-block text-base font-bold tracking-[0.2em] text-[#97BF49]">
              Travel Insurance Services
            </span>
            <h2 className="mt-5 text-[25px] font-semibold leading-[1.1] tracking-[0.2px] text-white sm:text-5xl lg:text-5xl">
              Travel with Confidence, Wherever You Go
            </h2>

            <p className="mt-5 max-w-[590px] text-[18px] font-normal leading-[1.62] text-white">
              Find the right travel insurance for you and your family with
              coverage designed around your journey. Get a quick quote and
              explore international and UAE-based travel insurance options for
              trips abroad or visits to family. Voyage Plus offers flexible
              plans tailored to your travel needs, with expert assistance to
              help you choose the right coverage with confidence.
            </p>

            <a href="/contact">
              <button
                className="
              mt-8
              h-[46px]
              w-[192px]
              bg-gradient-to-r from-[#99c04c] via-[#99c04c] to-[#99c04c]
              text-[16px]
              font-medium
              text-white
              transition
              rounded-lg
            "
              >
                Enquire Now
              </button>
            </a>
          </div>

          {/* Right Illustration */}
          <div className="relative h-[390px] md:w-[43%] overflow-hidden md:pt-0 pt-20">
            <img
              src={insurancevoyage}
              alt=""
              className="
            "
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Insurance;
